import { CustomSelect } from '../../vendors/custom-slect'

const mathMenu = () => {
  const select = new CustomSelect('#math-menu', {
    onSelected (select, option) {
      if (select.value && window.location.href !== select.value) {
        window.location.href = select.value
      }
    }
  })

  select.value = window.location.href
}

export default mathMenu
